module.exports = __webpack_public_path__ + "img/SL-M-220-300.0a8f4ee9.svg";